export const getEventEmailSchedules = state => state.eventEmailSchedules.data;

export const getEventEmailSchedule = (state, id) =>
  state.eventEmailSchedules.data
    ? state.eventEmailSchedules.data.find(d => d.id === id)
    : null;
